import { ILoginResponse } from "@faire/web-api/indigofair/data/ILoginResponse";
import { useCallback, useMemo } from "react";

import { useSSOContextStore } from "./SSOContextStore";

// ts-prune-ignore-next will use in followup PR
export const useSSOMFAStore = () => {
  const [{ mfaDescription, mfaTitle, mfaOptions }, setStore] =
    useSSOContextStore(["mfaDescription", "mfaTitle", "mfaOptions"]);

  const showSelectMFA = useMemo(() => {
    return mfaOptions.length !== 0;
  }, [mfaOptions]);

  const setMFADescription = useCallback(
    (description: string) => {
      setStore({
        mfaDescription: description,
      });
    },
    [setStore]
  );

  const resetMFADescription = useCallback(() => {
    setStore({
      mfaDescription: "",
    });
  }, [setStore]);

  const setMFATitle = useCallback(
    (title: string) => {
      setStore({
        mfaTitle: title,
      });
    },
    [setStore]
  );

  const resetMFATitle = useCallback(() => {
    setStore({
      mfaTitle: "",
    });
  }, [setStore]);

  const setMFAOptions = useCallback(
    (options: ILoginResponse.IMfaOption[]) => {
      setStore({
        mfaOptions: options,
      });
    },
    [setStore]
  );

  const resetMFAOptions = useCallback(() => {
    setStore({
      mfaOptions: [],
    });
  }, [setStore]);

  return {
    mfaDescription,
    mfaTitle,
    mfaOptions,
    showSelectMFA,
    setMFADescription,
    resetMFADescription,
    setMFATitle,
    resetMFATitle,
    setMFAOptions,
    resetMFAOptions,
  };
};
